import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissoesAcessoService } from './permissoes-acesso.service';
import { CadastroGrupoAcessoComponent } from './cadastro-grupo-acesso/cadastro-grupo-acesso.component';
import { CadastroUsuarioGrupoAcessoComponent } from './cadastro-usuario-grupo-acesso/cadastro-usuario-grupo-acesso.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { ListarGrupoAcessoComponent } from './listar-grupo-acesso/listar-grupo-acesso.component';
import { ListarUsuarioGrupoAcessoComponent } from './listar-usuario-grupo-acesso/listar-usuario-grupo-acesso.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { PermissoesTabsetComponent } from './permissoes-tabset/permissoes-tabset.component';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ListarUsuariosFiltroFuncionalidadeComponent } from './listar-usuarios-filtro-funcionalidade/listar-usuarios-filtro-funcionalidade.component';
import { ModalUsuariosFiltroFuncionalidadeComponent } from './modal-usuarios-filtro-funcionalidade/modal-usuarios-filtro-funcionalidade.component';
import { ListarUsuariosFiltroAreaComponent } from './listar-usuarios-filtro-area/listar-usuarios-filtro-area.component';
import { ModalUsuariosFiltroAreaComponent } from './modal-usuarios-filtro-area/modal-usuarios-filtro-area.component';

@NgModule({
    imports: [
        CommonModule,
        NgxPaginationModule,
        NgbModule,
        PipesModule,
        ComumModule,
        routing,
        FormsModule,
        LoadingModule.forRoot({
            animationType: ANIMATION_TYPES.circle
        }),
        ConfirmDialogModule
    ],
    declarations: [CadastroGrupoAcessoComponent, CadastroUsuarioGrupoAcessoComponent,
        ListarGrupoAcessoComponent, ListarUsuarioGrupoAcessoComponent, PermissoesTabsetComponent,
        ListarUsuariosFiltroFuncionalidadeComponent, ModalUsuariosFiltroFuncionalidadeComponent,
        ListarUsuariosFiltroAreaComponent, ModalUsuariosFiltroAreaComponent],
    exports: [CadastroGrupoAcessoComponent, CadastroUsuarioGrupoAcessoComponent,
        ListarGrupoAcessoComponent, ListarUsuarioGrupoAcessoComponent, PermissoesTabsetComponent,
        ListarUsuariosFiltroFuncionalidadeComponent, ModalUsuariosFiltroFuncionalidadeComponent,
        ListarUsuariosFiltroAreaComponent, ModalUsuariosFiltroAreaComponent],
    providers: [PermissoesAcessoService, ConfirmationService, CookieService]
})
export class PermissoesAcessoModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/permissoes-acesso.module.ts